const FinancialHelper = {
  getCapital(price, initialCapitalPercentage) {
    return (price / 100) * initialCapitalPercentage;
  },
  getTermInMonths(years) {
    return years * 12;
  },
  calculateEffectiveRate(
    realPrice,
    nominalInterest,
    years,
    monthlyCost,
    registrationCost,
    preparationFee
  ) {
    // Used Car -> Financial Calculator
    // Campaign Car -> Campaign Cars Archive

    const realPriceWithoutFees = realPrice - registrationCost - preparationFee;
    return +(
      ((monthlyCost * this.getTermInMonths(years) + preparationFee) /
        ((realPriceWithoutFees || 1) / 2) /
        years) *
        100 +
      nominalInterest
    );
  },
  calculateRealPrice(price, registrationCost, preparationFee, initialCapital) {
    // Used Car -> Financial Calculator
    // Campaign Car -> Campaign Cars Archive

    return Math.floor(
      price + registrationCost + preparationFee - initialCapital
    );
  },
  calculateMonthlyPrice(realPrice, nominalInterest, years, monthlyCost) {
    // Used Car -> Financial Calculator
    // Campaign Car -> Campaign Cars Archive

    return Math.floor(
      (realPrice * (nominalInterest / 100 / 12)) /
        (1 - Math.pow(1 / (1 + nominalInterest / 100 / 12), years * 12)) +
        monthlyCost
    );
  },

  calculateLeasingMonthlyFee(startingPrice, kilometerFee, upfrontFee) {
    // New Car/ Campaign Car -> Leasing
    return startingPrice + kilometerFee + upfrontFee;
  },
  calculateSubscriptionMonthlyFee(startingPrice, kilometerFee, durationFee) {
    // New Car/ Campaign Car -> Subscription
    return startingPrice + kilometerFee + durationFee;
  },

  // TODO Split
  calculateLeasingTotalPrice(startingPrice, kilometerFee, upfront) {
    // New Car/ Campaign Car -> Leasing
    const reservationFee = 5363;
    return (
      (startingPrice + kilometerFee + upfront.fee) * 36 +
      reservationFee +
      upfront.cost
    );
  },
  calculateSubscriptionTotalPrice(startingPrice, kilometerFee, duration) {
    // New Car/ Campaign Car ->  Subscription
    const reservationFee = 5363;
    return (
      (startingPrice + kilometerFee + duration.fee) * duration.years * 12 +
      reservationFee
    );
  },
};

export default FinancialHelper;
